import React, { Component } from 'react';
import * as apiCalls from '../lib/apiCalls'
import './Notify.css'
import '../components/Dropdown.css'
import Dropdown from '../components/Dropdown';
import { LanguageContext, LanguageConsumer } from '../lib/LanguageContext'

class Notify extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectorActive: false,
            messageTransition: false,
            send: false,
            messageSending: {
                loading: true,
                success: false
            },
           message: 'Eντοπίστηκαν αποκλίσεις στα στοιχεία του λογαριασμού σας στο σύστημα του Ιδρύματος. Παρακαλούμε επικοινωνήστε με τη γραμματεία του τμήματός σας.'
        }
    }

    closeModal = () => {
        this.props.closeModal();
    }

    selectorToggle = () => {
        this.setState(prevState=> ({
            ...prevState,
            selectorActive: !prevState.selectorActive
        }))
    }

    selectorClose = () => {
        this.setState(prevState => ({
            ...prevState,
            selectorActive: false
        }))
    }

    selectorHandleChange = (name, value) => {
        let messageSelection = this.state.selections.messageSelection
                .map(s => {
                    return {
                        ...s,
                        active: s.id === value 
                    }
                })
        this.setState(prevState => ({
            ...prevState,
                messageTransition: true,
                selections: {
                    ...prevState.selections,
                    messageSelection,
                }
        }))
        setTimeout(() => {
            this.setState(prevState => ({
            ...prevState,
                selectorActive: false
            }));
        }, 0) 
        setTimeout(() => {
            this.setState(prevState => ({
                ...prevState,
                    selections: {
                        ...prevState.selections,
                        messageId: value                       
                    },
                   messageTransition: false
                }));
        }, 300)
    }

    handleSend = async () => {
        this.setState(prevState => ({
            ...prevState,
            send: true,
            messageSending: {
                ...prevState.messageSending,
                loading: true
            }
        }))
        let res = await apiCalls.notifyUserSMS(this.props.objectId)
        let success = res.success
        this.props.updateNotified()
        this.setState(prevState => ({
             ...prevState,
             messageSending: {
                 ...prevState.messageSending,
                 success,
                 loading: false
             }
         }))
    }

    render() {
        return (
         <LanguageConsumer>
            {({polyglot}) =>
            (<div className='Notify'>
                    <div className="closeModal" onClick={this.closeModal}>
                        <div id='x-icon'>
                            <span />
                            <span />
                            <span />
                            <span />
                        </div>
                    </div>
                    <div className='content'>
                        <div className='content-header'>
                            <h2 className='header'>
                                <span className="far fa-envelope"></span> {polyglot.t('Notify.notifyStudent')}
                            </h2>
                            <p id='description'>{polyglot.t('Notify.description1')} <strong>{polyglot.t('Notify.sms')}</strong> {polyglot.t('Notify.description2')}</p>
                            <div className='recordInfo'>
                                <span> SystemId: {
                                   this.props.systemId ? (<span className='infoValue'>{this.props.systemId}</span>) : 
                                                         (<span className='infoValue'>-</span>)
                                 }
                                </span>,
                                <span> RegistrationId: {
                                   this.props.registrationId ? (<span className='infoValue'>{this.props.registrationId}</span>) :
                                                               (<span className='infoValue'>-</span>)
                                 }
                                </span>,
                                <span> {polyglot.t('Notify.mobilePhone')}: {
                                   this.props.mobilePhone ? (<span className='infoValue'>{this.props.mobilePhone}</span>) :
                                                            (<span className='infoValue'>-</span>)
                                }
                                </span>
                            </div>
                            {
                                    !this.state.send ? (
                                        <div className='message-preview'>
                                            <span className='message-preview-header'>{polyglot.t('Notify.messagePreview')}:</span>
                                            <div className={`message-preview-box 
                                                            ${this.state.messageTransition ? 'transition' : ''}`}>
                                                <p className='message-body'>{this.state.message}</p>
                                            </div>
                                        </div>
                                    )
                                    : (
                                        this.state.messageSending.loading
                                         ? ( <div className='message-loading'>
                                                <h3 className='loader-text'>Αποστολή Μηνύματος</h3>
                                                <div className="load-wrapp">
                                                    <div className="load-3">
                                                        <div className="line"></div>
                                                        <div className="line"></div>
                                                        <div className="line"></div>
                                                    </div>
                                                </div>
                                        </div>
                                        ) :
                                        (
                                            <div className={`messageSent ${this.state.messageSending.success ? 'success' : 'failure'}`}>
                                                <h2>
                                                    {
                                                        this.state.messageSending.success ? 
                                                            <div className="messageSent-wrap">
                                                                <span className="far fa-check-circle"></span> {polyglot.t('Notify.messageWasSuccessfullySent')}
                                                            </div> :
                                                            <div className="messageSent-wrap">                                                            
                                                                <span className="far fa-times-circle"></span> {polyglot.t('Notify.messageWasNotSuccessfullySent')}
                                                            </div>                                                         
                                                    }
                                                </h2>
                                            </div>
                                        )
                                    )
                            }
                        </div>
                        <div className='footer-wrapper'>  
                            {
                                !this.state.send ?
                                    <div className='footer'>
                                        <button id='cancel' onClick={this.closeModal}>{polyglot.t('Notify.cancel')}</button>
                                        <button id='send' onClick={this.handleSend}>{polyglot.t('Notify.send')}</button>
                                    </div> :
                                    <div className='footer'>
                                        <button id='close' onClick={this.closeModal}>{polyglot.t('Notify.close')}</button>
                                    </div>
                            }
                        </div>
                    </div>
                </div>)}
          </LanguageConsumer>
        )
   }
}
Notify.contextType = LanguageContext

export default Notify;



// WEBPACK FOOTER //
// ./src/results/Notify.js